import { FC, useEffect, useState } from "react";
import { Button, Form, message, DatePicker, Select, Image } from "antd";
import { useNavigate } from "react-router-dom";
import Card from "antd/es/card/Card";
import { ReservationRequest } from "../../shared/types/request/reservationRequest.model";
import { useReservation } from "../../shared/services/planning/planning.service";
import { TokenValid } from "../../shared/types/request/tokenvalid.model";
import { useIsTokenValid } from "../../shared/services/security/security.service";
import "../../shared/style/antd-scrollliste.css";

const { RangePicker } = DatePicker;

const Reservation : FC = () => {

    const navigate = useNavigate()

    const[tokenRequest, setTokenRequest] = useState<TokenValid>();
    
    const {errorToken} = useIsTokenValid(tokenRequest);

    useEffect(() => {
        const handler = (e : any) => {
            if (e.target.closest(".no-page-scroll-select")) {
                e.stopPropagation();
            }
        };

        document.addEventListener("wheel", handler, { passive: false });

        return () => document.removeEventListener("wheel", handler);
    }, []);
    
    useEffect(() => {
        const request: TokenValid = {
            username: localStorage.getItem("username") || "",
            token: localStorage.getItem("token") || ""
        };
        setTokenRequest(request);
    }, [])

    useEffect(() => {
        if(errorToken){
            navigate("/connexion");
        }
    }, [errorToken])

    function retourEspaceUser() {
        navigate("/espaceuser")
    }

    const [formValues, setFormValues] = useState<ReservationRequest>();

    const {data, isLoading, error} = useReservation(formValues);

    const onFinish = (values: any) => {
        const [start, end] = values.reservation;

        const request: ReservationRequest = {
            username: localStorage.getItem('username') || "",
            dateDebut: start.format("DD/MM/YYYY"),
            dateFin: end.format("DD/MM/YYYY"),
            numPoste: Number(values.numPoste)
        };
        setFormValues(request);
    };

    const[messageApi, contextHolder] = message.useMessage();

    useEffect(() =>{
        if(error && error.response.data.erreur){
            messageApi.error("Une erreur est survenue : " + error.response.data.erreur);
        }else{
            if(error)
            {
                messageApi.error("Une erreur est survenue : " + error.message);
            }
        }
    }, [error])

    useEffect(() => {
        if(data && data.ok){
            messageApi.success(data.ok);
        }
    }, [data])

    const options = Array.from({ length: 23 }, (_, i) => ({
        value: i + 1,
        label: <span>Poste {i + 1}</span>,
    }));

    return(
        <div>
            <Card title={<span style={{ textAlign: "center" }}>Réservation de votre créneau</span>} variant="borderless" className="responsive-card">
                {contextHolder}
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        label="Date de réservation"
                        name="reservation"
                        rules={[{required: true, message: "Les dates sont requis"}]}
                    >
                        <RangePicker format={"DD/MM/YYYY"} />
                    </Form.Item>
                    <Form.Item
                        label="Numéro de poste"
                        name="numPoste"
                        rules={[{required: true, message: "Le numéro de poste est requis"}]}
                    >
                    <Select style={{width: "60%"}} options={options} 
                      classNames={{
                        popup: {
                        root: "no-page-scroll-select"
                        }
                    }} />
                    </Form.Item>
                    <Button type="primary" loading={isLoading} htmlType="submit">
                        Réserver
                    </Button>
                </Form>
                <Button onClick={retourEspaceUser} style={{ marginTop: "24px" }}>Retour</Button>
            </Card>
            <div style={{ textAlign: "center" }}>
                 <Image
                    style={{ maxWidth: "100%", height: "auto" }}
                    src={`${process.env.PUBLIC_URL}/PlanPeche.jpg`}
                />
            </div>
        </div>
    )
}

export default Reservation;